module.exports = __webpack_public_path__ + "jp.3e48805dda36f8e170d9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/jp.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/jp.svg
// module chunks = styles